import { COLOR_FILTERS_STATUS, type ReportData } from '@ipfabric/utils';
import type { TableReports } from 'components/Table/model/TableModel';
import type { ApiTableCommandFactory } from '../ApiTableModel';

interface CreateTableReportCommand {
  data: Omit<ReportData, 'status'>[];
}

export const createTableReport: ApiTableCommandFactory<
  CreateTableReportCommand
> = (cmdContext) => async (command) => {
  const { reports } = cmdContext.getState();

  const newReports = command.data.reduce<TableReports>((acc, data) => {
    acc[data.column] = {
      ...data,
      status: COLOR_FILTERS_STATUS.run,
    };

    return acc;
  }, reports);

  cmdContext.updateState((draft) => {
    draft.reports = {
      ...reports,
      ...newReports,
    };
  });
};
